export class MinimumBrowserVersion {
	public static Chrome = 120;
}

export class ValidationConstants {
	public static posiviteCurrencyRegex: string =
		'(\\d{1,12}|[1-9]{1}(\\d{1,2})?,?\\d{3}|[1-9]{1}(\\d{1,2})?,\\d{3},?\\d{3}|[1-9]{1}(\\d{1,2})?,\\d{3},?\\d{3},?\\d{3})';
	public static nonZeroPosiviteCurrencyRegex: string =
		'([1-9]{1}(\\d{1,11})?|[1-9]{1}(\\d{1,2})?,?\\d{3}|[1-9]{1}(\\d{1,2})?,\\d{3},?\\d{3}|[1-9]{1}(\\d{1,2})?,\\d{3},?\\d{3},?\\d{3})';
	public static phoneNumberRegex: string =
		'^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})$';
	public static phoneNumberRegexSevenDigit: string =
		'^[ ]*[0-9]{3}[\\- ]?[0-9]{4}[ ]*$';
	public static isNumberRegex: string = '^\\d{1,15}$';
	public static alphaSpaceOnly: string = '^[A-Za-z ]+$';
	public static alphaNumericSpaceOnly: string = '^[a-zA-Z0-9 ]*$';
	public static zipcode: string = '^\\d{5}(-\\d{4})?$';
	public static formatedNumberRegex: string =
		'(\\d{1,12}|[1-9]{1}(\\d{1,2})?,?\\d{3}|[1-9]{1}(\\d{1,2})?,\\d{3},?\\d{3}|[1-9]{1}(\\d{1,2})?,\\d{3},?\\d{3},?\\d{3})';

	/* Pulled from: https://stackoverflow.com/questions/30970068/js-regex-url-validation/30970319 */
	public static urlRegex: string =
		'^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$';
}

export enum BootstrapTypes {
	default = 'default',
	success = 'success',
	info = 'info',
	warning = 'warning',
	danger = 'danger',
}

export const HTTP_NO_PERMISSION = 'NO PERMISSION';

export const ACHIEVEPOINT_PROGRAMS: readonly number[] = [
	237, 687, 690, 696, 2921,
];

export const PROTECTED_EMAIL_DOMAINS: readonly string[] = [
	'@gradally.com',
	'@graduationalliance.com',
	'@riseonlinestudent.org',
	'@achievepoint.org',
	'@andrewshighschool.com',
	'@cgbethelhs.com',
	'@chambershigh.com',
	'@mainstreethigh.com',
	'@pbpca.com',
	'@pbpcamiddle.com',
	'@smcurtishighschool.com',
];

export const PASSWORD_RESTRICTIONS: readonly string[] = [
	'password',
	'passw0rd',
	'changeme',
	'qwerty',
	'12345',
];

export const BARRIER_OPTIONS: readonly string[] = [
	'Emotional Violence inside or outside the home',
	'Family Disruption',
	'Financial Instability',
	'Food Instability',
	'Heightened Anxiety',
	'Heightened Depression',
	'Homelessness',
	'Interpersonal Conflict',
	'Physical Violence inside or outside the home',
	'Suicidal Ideation',
	'Suicidal Intent',
	'Transportation',
	'Unstable Housing',
];

export const SITE_ADMINISTRATOR = 'site_admin';

/** Sourced from https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
export const USA_TIMEZONES: readonly string[] = [
	'Pacific/Honolulu',
	'America/Los_Angeles',
	'America/Phoenix',
	'America/Denver',
	'America/Chicago',
	'America/New_York',
	'America/Anchorage',
];

export const personalInfoFields = ['student_data', 'profile', 'contact_field'];

export const fields: {
	key: string;
	title: string;
	type?: string;
	index?: number;
	invalid?: boolean;
	group?: string;
	secondary?: string;
	component?: string;
}[] = [
	{
		key: 'profile_first_name',
		title: 'First Name',
		group: 'profile',
	},
	{
		key: 'profile_middle_name',
		title: 'Middle Name',
		group: 'profile',
	},
	{
		key: 'profile_last_name',
		title: 'Last Name',
		group: 'profile',
	},
	{
		key: 'profile_maiden_name',
		title: 'Maiden Name',
		group: 'profile',
	},
	{
		key: 'profile_preferred_name',
		title: 'Preferred Name',
		group: 'profile',
	},
	{
		key: 'profile_suffix',
		title: 'Suffix',
		group: 'profile',
	},
	{
		key: 'profile_field_race',
		title: 'Race',
		group: 'profile',
	},
	{
		key: 'profile_field_ethnicity',
		title: 'Ethnicity',
		group: 'profile',
	},
	{
		key: 'profile_student_gender',
		title: 'Gender',
		group: 'profile',
	},
	{
		key: 'dob',
		title: 'Date of Birth',
		type: 'date',
		group: 'student_data',
	},
	{
		key: 'language_primary',
		title: 'Primary Language',
		group: 'student_data',
	},
	{
		key: 'language_home',
		title: 'Home Language',
		group: 'student_data',
	},
	{
		key: 'language_primary_other',
		title: 'Primary Language Other',
		group: 'student_data',
	},
	{
		key: 'language_home_other',
		title: 'Home Language Other',
		group: 'student_data',
	},
	{
		key: 'cohort_year',
		title: 'Cohort Year',
		group: 'student_data',
	},
	{
		key: 'student_id',
		title: 'Student ID',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'track',
		title: 'Track',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'timezone',
		title: 'Timezone',
		group: 'user',
		component: 'student_info',
	},
	{
		key: 'phone',
		secondary: 'phone_numbers',
		title: 'Phone',
		type: 'phone',
		group: 'contact_field',
	},
	{
		key: 'physical_address',
		title: 'Physical Address',
		type: 'address',
		group: 'contact_field',
	},
	{
		key: 'mailing_address',
		title: 'Mailing Address',
		type: 'address',
		group: 'contact_field',
	},

	// Special fields for Student info tab that don't fit into the above groups
	/**
	 * custom_district=>student_data.custom_district
	 */
	{
		key: 'attendance_class',
		title: 'Attendance Class',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'profile_student_year',
		title: 'Grade',
		group: 'profile',
		component: 'student_info',
	},
	{
		key: 'profile_student_id',
		title: 'Profile Student ID',
		group: 'profile',
		component: 'student_info',
	},
	{
		key: 'state_id',
		group: 'enrollment',
		title: 'State ID',
		component: 'student_info',
	},
	{
		key: 'courses_concurrent', // attendance_class
		title: 'Courses Concurrent',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'district_id',
		title: 'District ID',
		group: 'enrollment',
		component: 'student_info',
	},
	{
		key: 'calculated_grade',
		title: 'Calculated Grade',
		group: 'graduation_progress',
		component: 'student_info',
	},
	{
		key: 'graduation_plan_id', // graduation_plan_id
		title: 'Graduation Plan',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'sr_pay_level',
		title: 'SR Pay Level',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'sr_pay_level_notes',
		title: 'SR Pay Level Notes',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'more_other',
		secondary: 'student_memo',
		title: 'More Other',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'district_residence',
		title: 'District of Residence',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'student_location',
		title: 'Student Location',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'throttle_status',
		title: 'Throttle Status',
		group: 'laptop_override',
		component: 'student_info',
	},
	{
		key: 'custom_district',
		title: 'Custom District',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'student_theme',
		title: 'Student Theme',
		group: 'user',
		component: 'student_info',
	},
	{
		key: 'mobile_theme',
		title: 'Mobile Theme',
		group: 'user',
		component: 'student_info',
	},
	{
		key: 'student_given_id',
		title: 'Student Given ID',
		group: 'student_data',
		component: 'student_info',
	},
	{
		key: 'profile_user_title',
		title: 'User Title',
		group: 'profile',
		component: 'student_info',
	},
	{
		key: 'profile_pronunciation',
		title: 'Pronunciation',
		group: 'profile',
		component: 'student_info',
	},
];

export const roles = [
	{
		title: 'Anonymous user',
		key: 'anonymous',
		is_assignable: false,
		has_permission_to_assign: false,
	},
	{
		title: 'Authenticated user',
		key: 'authenticated',
		is_assignable: false,
		has_permission_to_assign: false,
	},
	{
		title: 'Self Registered',
		key: 'self_registered',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Student',
		key: 'student',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Test Account',
		key: 'test_account',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Enrolled',
		key: 'enrolled',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'System Account',
		key: 'system_account',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Homeschooler',
		key: 'homeschooler',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Parent',
		key: 'parent',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Counselor',
		key: 'counselor',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Assistant',
		key: 'assistant',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'SchoolAdministrator',
		key: 'school_administrator',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Proctor',
		key: 'proctor',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Registrar',
		key: 'registrar',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Gatekeeper',
		key: 'gatekeeper',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'SpecialEdDirector',
		key: 'special_ed_director',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'BusinessManager',
		key: 'business_manager',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Credentialed Responder',
		key: 'credentialed_responder',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Mapper',
		key: 'mapper',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Grader',
		key: 'grader',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Teacher',
		key: 'teacher',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Blog Editor',
		key: 'blog_editor',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Staff (no access)',
		key: 'staff_no_access',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Staff',
		key: 'staff',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Background Checker',
		key: 'background_checker',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Staff_TE',
		key: 'staff_te',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Staff: Early Access',
		key: 'staff_ea',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'TranscriptCoordinator',
		key: 'transcript_coordinator',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Grad Coordinator',
		key: 'grad_coordinator',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'GACounselor',
		key: 'ga_counselor',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Tutor',
		key: 'tutor',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Advocate',
		key: 'advocate',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Advocate Lead',
		key: 'advocate_lead',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Recruiter',
		key: 'recruiter',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Case Manager',
		key: 'case_manager',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Recruiter Manager',
		key: 'recruiter_manager',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'ProgramManager',
		key: 'program_manager',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Testing Coordinator',
		key: 'testing_coordinator',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'College & Career Counselor',
		key: 'career_counselor',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'OnlineMentor',
		key: 'online_mentor',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Family Advocate',
		key: 'family_manager',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Learning Coach',
		key: 'learning_coach',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Re-entry Coordinator',
		key: 'reentry_coordinator',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Re-entry Coach',
		key: 'reentry_coach',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Charter Staff',
		key: 'charter_staff',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Academy Admin',
		key: 'academy_admin',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Online Mentor Lead',
		key: 'online_mentor_lead',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'TAA Academic Coach',
		key: 'taa_academic_coach',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Student Services Manager',
		key: 'academic_coach_manager',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'SAFE Admin',
		key: 'safe_admin',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Bookkeeper',
		key: 'bookkeeper',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'TeacherLead',
		key: 'teacher_lead',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'GA Registrar',
		key: 'ga_registrar',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'GA Principal',
		key: 'principal',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Curriculum',
		key: 'curriculum',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'GA Data Services',
		key: 'ga_data_services',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'ContentAdmin',
		key: 'content_admin',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'HR',
		key: 'hr',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Campus Manager',
		key: 'campus_manager',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Compliance',
		key: 'compliance',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Operations Lead',
		key: 'operations_lead',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Operations Admin',
		key: 'operations_admin',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Helpdesk Tech',
		key: 'helpdesk_tech',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'Developer',
		key: 'developer',
		is_assignable: true,
		has_permission_to_assign: true,
	},
	{
		title: 'SiteAdmin',
		key: 'site_admin',
		is_assignable: true,
		has_permission_to_assign: false,
	},
];

export const permittedProfanityWords: readonly string[] = [
	'gaylord',
	'fanny',
	'bloody',
	'pawn',
	'willies',
	'willy',
	'flange',
];

export const classroomTermTypes: readonly {
	id: number;
	short: string;
	long: string;
}[] = [
	{ id: 1, short: 'Q', long: 'Quarter' },
	{ id: 2, short: 'Sem', long: 'Semester' },
	{ id: 3, short: 'CR', long: 'Full Credit' },
];

export const classroomActivityTypes: readonly {
	value: string;
	label: string;
}[] = [
	{
		value: 'learning_hub',
		label: 'Learning Hub',
	},
	{
		value: 'pod_hub',
		label: 'Pod Hub',
	},
	{
		value: 'your_turn',
		label: 'Your Turn',
	},
	{
		value: 'unstructured',
		label: 'Unstructured',
	},
	{
		value: 'recess',
		label: 'Recess',
	},
	{
		value: 'study',
		label: 'Study',
	},
];
